import React from 'react';
import { getStatusColor } from '../lib/formatters';

export const StatusBadge = ({ status }) => {
  const colors = {
    pending: 'bg-yellow-100 text-yellow-700',
    approved: 'bg-green-100 text-green-700',
    rejected: 'bg-red-100 text-red-700',
    completed: 'bg-blue-100 text-blue-700',
    processing: 'bg-blue-100 text-blue-700',
  };

  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`px-3 py-1 rounded-full text-xs font-medium ${colors[status] || colors.pending}`}
    >
      {status.toUpperCase()}
    </span>
  );
};